import { render, staticRenderFns } from "./WikiPageTemplateEdit.vue?vue&type=template&id=1ae4bfae&scoped=true"
import script from "./WikiPageTemplateEdit.vue?vue&type=script&lang=ts"
export * from "./WikiPageTemplateEdit.vue?vue&type=script&lang=ts"
import style0 from "./WikiPageTemplateEdit.vue?vue&type=style&index=0&id=1ae4bfae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae4bfae",
  null
  
)

export default component.exports